export const KEY_CODES = Object.freeze({
	ENTER: "Enter",
	ESCAPE: "Escape",
	SPACE: "Space",
});
